import React, { useContext, useState } from "react";
import { PopupContext, TableContext } from "../index";
import { showSuccessToast, showWarningToast } from "../validation/ToastContainer";
import { getDeletePopup } from "../view/popup/PopupContainer";
import * as recipientService from "./mailRecipientService"
import { AddRecipientModal } from "./AddRecipientModal";
import { Plus, Trash2 } from "lucide-react";
function AdditionalRecipientTableHeader() {

    const [showModal, setShowModal] = useState(false);

    const { config, setConfig } = useContext(TableContext)
    const { setPopup } = useContext(PopupContext);
    const hasSelection = !!(config.selected && config.selected.length > 0);

    const onConfirm = async () => {

        if (!config.selected || config.selected.length === 0) {
            return showWarningToast('No selected recipients to delete', 'Remove Recipient', 'aborted');
        }
        await recipientService.deleteRecipients(config.selected)
        setConfig({ ...config, lastUpdated: Date.now() });
        showSuccessToast('Selected recipients were removed', 'Remove Recipient', 'success');
    }

    const askBeforeDelete = () => {
        setPopup(
            getDeletePopup('Are you sure you want to remove the selected recipients?',
                'Remove Recipients',
                () => onConfirm(),
                undefined,
                'Remove Recipients'
            )
        );
    }

    return (
        <>
            {showModal && <AddRecipientModal closeModal={() => setShowModal(false)} />}
            <div className="oct_analysis-header-v2 mt-0 border-0">
                <div className="oct_analysis-actions">
                    <button
                        className="oct_btn-export-v2"
                        onClick={() => setShowModal(true)}
                    >
                        <Plus className="oct_icon" /> Add
                    </button>
                    <button
                        className="oct_btn-danger-v2"
                        onClick={() => askBeforeDelete()}
                        disabled={!hasSelection}
                    >
                        <Trash2 className="oct_icon" />
                        Remove
                    </button>
                </div>
            </div>
        </>
    );
}

export default AdditionalRecipientTableHeader;
